export const NotificationMessages = {
  OperationSuccess: 'Operación satisfactoria',
  DeleteSuccess: 'Se eliminó el elemento satisfactoriamente',
  DeleteError: 'No se pudo eliminar el elemento',
  AddError: 'No se pudo adicionar el elemento',
  AddItemsError: 'No se pudo adicionar los elementos',
  UpdateError: 'No se pudo adicionar el elemento',
};

export const NotificationType = {
  success: 'success',
  error: 'error',
};
